import WithLoadable from 'components/WithLoadable';

export default WithLoadable(() => import(/* webpackChunkName: "register-page" */ './index'));
